import React from 'react';
import {InfoPage, RsnButton} from '~/library/ui-kit';

export function SessionExpired({onStartAgain}: {onStartAgain: () => void}) {
    return (
        <div className='flex h-full flex-1 flex-col'>
            <InfoPage.Layout symbol={'failure'}>
                {{
                    center: (
                        <InfoPage.Center
                            heading={
                                <>
                                    Password recovery <br /> session expired
                                </>
                            }
                            details={'Start password recovery again to continue.'}
                        />
                    ),
                    footer: (
                        <InfoPage.Footer>
                            <RsnButton.Primary type='submit' onClick={onStartAgain}>
                                Start again
                            </RsnButton.Primary>
                        </InfoPage.Footer>
                    ),
                }}
            </InfoPage.Layout>
        </div>
    );
}
